module.exports = __webpack_public_path__ + "img/img_tc_tu1.54baeb34.png";